import headerComponent from '@/components/cust_components/cust_header_component.vue';
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
import axios from 'axios';
 
Vue.use(VueCryptojs)

export default {
    name: 'login',
    components:{
        headerComponent,
    
    },
    data(){
        return {
            mobile_view : false,
            password:'',
            password_validation:'',
            passwordFieldType: 'password',
            confirm_password:'',
            confirmPassword_validation : '',
            confirmPwdFieldType:'password',
            pwd_img : 'password_close_icon.svg',
            confirm_pwd_img :'password_close_icon.svg',
            all_validations_passed :false,
            isClicked : false
          

        }
    },
    mounted(){
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.$route.params.email
        this.$route.params.resetkey
    },
    methods:{
        async responsive_view(){

            await this.$store.commit('responsive_view', window.innerWidth)
           
        },
        password_validation_check(){
            this.password= this.password.trim();
            this.password_validation = ''
            if(this.password.length == 0){
                this.all_validations_passed = false 
                this.password_validation = 'Please enter valid password'
            }
        },
        confirm_password_validation_check(){
            this.confirm_password= this.confirm_password.trim();
            this.confirmPassword_validation = ''
            if(this.confirm_password.length == 0){
                this.all_validations_passed = false 
                this.confirmPassword_validation = 'Please enter valid password'
            }
            if(this.password!=this.confirm_password){
                this.all_validations_passed = false 
                this.confirmPassword_validation = 'Password not matched'
            }
        },
        login(){
            this.$router.push('/custlogin')
        },
        switchVisibilityPassword() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'  
            this.pwd_img =   this.passwordFieldType === 'password' ? 'password_close_icon.svg' : 'password_show_icon.svg';  

        },
        switchVisibilityConfirmPassword() {
            this.confirmPwdFieldType = this.confirmPwdFieldType === 'password' ? 'text' : 'password';
            this.confirm_pwd_img =   this.confirmPwdFieldType === 'password' ? 'password_close_icon.svg' : 'password_show_icon.svg';  
        },
        validation_check(){
            this.all_validations_passed = true;
            this.password_validation_check();
            this.confirm_password_validation_check();
        },
        submit(){
            this.validation_check();
            if(this.all_validations_passed){
                this.isClicked = true;
                var ciphertext = this.CryptoJS.AES.encrypt(this.password,this.Constants.CRYPTO_KEY).toString();
                axios.post(this.$store.state.api + `v2/customer/reset_password_v2`, {
                    "encoded_cust_email":  this.$route.params.email,
                    "reset_pswd_key": this.$route.params.resetkey,
                    "new_password": ciphertext
                }).then(response => {
                    this.isClicked = false;
                    if (response.status === 200) {
                    this.$router.push('/passwordupdate');
                    }
                }).catch(error => {  
                    this.isClicked = false;
                    if (error.response.status === 400) {
                    this.confirmPassword_validation = "The provided url expired.";
                    }
                }) 
            }
            

        },
    }
}